export enum SERVICES_TYPE {
  CREDIT = 0,
  BNPL_4PAY = 1,
  BNPL_1PAY = 2,
  COIN = 3,
  CASHBACK = 4,
  INSURANCE = 5,
  BNPL_6PAY = 6,
  MERCHANT_CASHBACK = 7,
  H_BNPL_4PAY = 30,
  H_BNPL_1PAY = 31,
  H_BEYOND_INSURANCE = 32,
  H_FULL_INSURANCE = 33,
  H_COMPREHENSIVE_INSURANCE = 34,
  H_AFFORDABLE_INSURANCE = 35,
  H_DELIVERY_GUARANTY = 36,
  H_DISCOUNT_STORES = 37,
  H_DOCUMENT_FREE_SHIPPING = 38,
  H_WEALTH = 39,
  H_DISCOUNT_INSURANCE = 40,
  H_SUPPORT = 41,
}
